<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Services</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Services</li>
            </ul>
        </div>
    </div>
    <div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
     </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Area -->

<div class="ai-services-area ptb-100">
    <div class="container-fluid">
        <!-- <div class="section-title title-with-underline" style="max-width: 1275px !important; margin-bottom: 60px"
            data-aos="fade-down">
            <h2>
                Our Services With Artificial Intelligence
            </h2>
            <p>
                Explore a diverse array of services empowered by Artificial
                Intelligence with us.
            </p>
            <img src="assets/img/RO.gif" style="height: 30px; margin-top: 5px" />
        </div> -->

        <div class="row justify-content-center">
            <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                <a routerLink="/inBound">
                <div class="ai-services-card" style="
                        background-image: url(assets/img/cardbg/what-removebg-preview.png);
                    ">
                    <div class="row justify-content-center">
                        <div class="services-image">
                            <img src="assets/img/Male agent working in call center.gif" alt="image"
                                style="max-width: 100%" />
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="services-content">
                            <h3>
                                <a routerLink="/inBound">Inbound Call Center </a>
                            </h3>

                            <a routerLink="/inBound" class="arrow">→</a>

                        </div>
                    </div>
                </div>
            </a>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                <a routerLink="/outBound">
                <div class="ai-services-card" style="
                        background-image: url(assets/img/cardbg/outboundbg-removebg-preview.png);
                    ">
                    <div class="row justify-content-center">
                        <div class="services-image">
                            <img src="assets/img/Push Marketing.gif" alt="image" style="max-width: 100%" />
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="services-content">
                            <h3>
                                <a routerLink="/outBound"> Outbound Marketing</a>
                            </h3>

                            <a routerLink="/outBound" class="arrow">→</a>
                        </div>
                    </div>
                </div>
            </a>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">
                
                <a routerLink="/coming-soon">
                <div class="ai-services-card" style="
                        background-image: url(assets/img/cardbg/tourbg-removebg-preview.png);
                    ">
                    <div class="row justify-content-center">
                        <div class="services-image">
                            <img src="assets/img/Whatsapp.gif" alt="image" style="max-width: 100%" />
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="services-content">
                            <h3>
                                <a routerLink="/coming-soon">Bulk WhatsApp Sender</a>
                            </h3>

                            <a routerLink="/coming-soon" class="arrow">→</a>
                        </div>
                    </div>
                </div>
                </a>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 service-card" data-aos="zoom-in-down">

                <a routerLink="/coming-soon">
                <div class="ai-services-card" style="
                       background-image: url(assets/img/cardbg/edubg-removebg-preview.png);
                    ">
                    <div class="row justify-content-center">
                        <div class="services-image">
                            <img src="assets/img/Sms.gif" alt="image" style="max-width: 100%" />
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="services-content">
                            <h3>
                                <a routerLink="/coming-soon">Bulk Messenger</a>
                            </h3>

                            <a routerLink="/coming-soon" class="arrow">→</a>
                        </div>
                    </div>
                </div>
            </a>
            </div>

        </div>
    </div>
</div>
<!-- <section class="services-area ptb-110 bg-fafafa">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6" data-aos="zoom-in-down">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/ai-solution/features/inound.png" alt="image">
                    </div>
                    <h3><a routerLink="/inBound">Inbound Call Center</a></h3>
                    <p>Unlock the potential of AI speech bots to enhance your inbound calls intelligently. Optimize processes, reduce wait times, and seamlessly integrate automation with human interaction for effective service delivery and increased customer satisfaction.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6" data-aos="zoom-in-down">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/ai-solution/features/outbound.png" alt="image">
                    </div>
                    <h3><a routerLink="/outBound">Outbound Marketing</a></h3>
                    <p>Elevate your outbound marketing endeavors with the powerful capabilities of VocBot.This invaluable tool enhances <br>efficiency through various features. Experience seamless scalability, allowing you to transition <br>effortlessly.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6" data-aos="zoom-in-down">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/ai-solution/features/whatsapp.png" alt="image">
                    </div>
                    <h3><a routerLink="/bulkWhatsApp">Bulk WhatsApp Sender</a></h3>
                    <p>Empower your messaging strategy with the Bulk WhatsApp Sender feature on Vocbot  . Seamlessly send messages at scale, enhancing communication efficiency.you can reach a broader audience, ensuring that your messages are delivered promptly and effectively.</p>
                </div>
            </div>

            
        </div>
    </div>

    
</section> -->
<!-- End Services Area -->
